<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  result: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['done']);

const { t } = useI18n();

const scenarios = computed(() => props.result.scenarios || []);
const pendingTools = computed(() => props.result.pending_tools || []);
</script>

<template>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-2">
      <span class="text-xs font-medium uppercase tracking-wide text-n-slate-10">
        {{ t('CAPTAIN.ASSISTANTS.PRESET.CREATED_TITLE') }}
      </span>
      <div class="flex flex-col gap-1">
        <div
          v-for="scenario in scenarios"
          :key="scenario.id"
          class="flex items-center gap-2 text-sm text-n-slate-12"
        >
          <span class="i-lucide-check text-n-teal-11" />
          {{ scenario.title }}
        </div>
      </div>
    </div>

    <div
      v-if="pendingTools.length"
      class="flex flex-col gap-2 p-4 rounded-lg border border-n-weak bg-n-alpha-1"
    >
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('CAPTAIN.ASSISTANTS.PRESET.PENDING_TITLE') }}
      </span>
      <span class="text-xs text-n-slate-11">
        {{ t('CAPTAIN.ASSISTANTS.PRESET.PENDING_DESCRIPTION') }}
      </span>
      <div class="flex flex-col gap-1 pt-1">
        <div
          v-for="tool in pendingTools"
          :key="tool.template_id"
          class="flex items-center gap-2 text-sm text-n-slate-12"
        >
          <span class="i-lucide-wrench text-n-slate-10" />
          {{ tool.title }}
        </div>
      </div>
    </div>

    <div class="flex justify-end pt-2">
      <Button
        type="button"
        color="blue"
        :label="t('CAPTAIN.ASSISTANTS.PRESET.DONE')"
        @click="emit('done')"
      />
    </div>
  </div>
</template>
